export function arrayToObj<T>(items: T[], itemKey: keyof T) {
  return items.reduce((acc, item) => {
    let key = item[itemKey];
    if (Array.isArray(key)) [key] = key;
    if (typeof key !== 'string' && typeof key !== 'number') throw Error('Wrong itemKey');
    acc[(key as string)] = item;
    return acc;
  }, {} as Record<string, T>);
}
